import React from 'react';
import { FormInputWrapper } from '../../styles/common-styles'
import { Select, InputLabel, FormControl, FormHelperText, ListSubheader, Tooltip } from '@material-ui/core';
import { getOptions, getOptionsGroups, getOptionsInactive } from '../../helper';
import { useEffect, useState } from 'react';

const MenuProps = {
    getContentAnchorEl: null,
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "left",
    }
};

/**
 * @param {{
 * label: string, 
 * labelId: string, 
 * formikValue: Object, 
 * formikChange: Function, 
 * isDoubled?: Boolean,
 * errors?: formik.errors.labelId,
 * touched?: formik.touched.labelId,
 * mandatory: Boolean,
 * dropdownData:Object '{optionLists,key,value}'
 * disabled: Boolean
 * sortAsc: Boolean
 * showBlankDefaultOption: Boolean
 * }} props 
 */
export const SelectInput = (props) => {
    const { SoValueZero,SoValueEmpty,SoValueNull,SoValueNegative, customStyle, label, labelId, withoutLabel = false, formikValue, formikChange, isDoubled, errors, touched, mandatory, dropdownData, disabled, sortAsc = false, onTooltip, showBlankDefaultOption = false, title, useEllipsis = false } = props; 

    const [list, setList] = useState({ key: "", value: '', optionLists: [] })
    const [bindDropdownValue, setBindDropdownValue] = useState({})
    const [isTooltip, setTooltip] = useState(true);

    useEffect(()=>{
        if(SoValueZero){
            setBindDropdownValue({
                "uniqueId": 0,
                "displayText": '<Select one>',
                "isSelected": false
            })
        }
        if(SoValueEmpty){
            setBindDropdownValue({
                "uniqueId": '',
                "displayText": '<Select one>',
                "isSelected": false
            })
        }
        if(SoValueNull){
            setBindDropdownValue({
                "uniqueId": null,
                "displayText": '<Select one>',
                "isSelected": false
            })
        }
        if(SoValueNegative){
            setBindDropdownValue({
                "uniqueId": -1,
                "displayText": '<Select one>',
                "isSelected": false
            })
        }
    },[SoValueZero,SoValueEmpty,SoValueNull,SoValueNegative])

    useEffect(() => {
        if (dropdownData?.optionLists?.length > 0) {
            const updatedList = dropdownData.optionLists.map((v, i) => {
                if (window.location.hash.indexOf('/system-manager/lookup-table-options/custom-grade-entry') > -1) {
                    if (v[dropdownData.key] === '' && Number(v[dropdownData.value]) === 0) {
                        v[dropdownData.key] = 'Default'
                    }
                } else if (!showBlankDefaultOption){
                    if (v[dropdownData.key] === '' && Number(v[dropdownData.value]) === 0) {
                        v[dropdownData.key] = '<Select one>'
                    } else if (v[dropdownData.key] === '') {
                        v[dropdownData.key] = '<Select one>'
                    } 
                } else if (v[dropdownData.key] === '') {
                    // Empty character to preserve styles when not having a default <Select one> option
                    v[dropdownData.key] = '\u00A0'  
                }
                return v
            })
            setList({
                ...list,
                key: dropdownData.key,
                value: dropdownData.value,
                optionLists: ( Object.keys(bindDropdownValue).length > 0) ?
                    [bindDropdownValue,
                    ...updatedList
                    ]
                    :
                    updatedList
            })
        }
        else {
            setList({
                ...list,
                key: '',
                value: '',
                optionLists: []
            })
        }
    }, [dropdownData])

    if (sortAsc) {
        list.optionLists.sort((a, b) => {
            if (a.displayText != null) {
                if (a.displayText.startsWith("<") && a.displayText.endsWith(">")) {
                    return -1;
                }
                if (b.displayText.startsWith("<") && b.displayText.endsWith(">")) {
                    return 1;
                }
                if (a.displayText.toLowerCase() < b.displayText.toLowerCase()) {
                    return -1;
                }
                if (a.displayText.toLowerCase() > b.displayText.toLowerCase()) {
                    return 1;
                }
                return 0;
            }
        });
    }

    return (
        <FormInputWrapper style={customStyle}
            isDoubled={isDoubled ? isDoubled : null}
            className={isDoubled ? 'doubled' : null}
        >
            {withoutLabel ?
                <FormControl variant={"outlined"} fullWidth>
                    <InputLabel htmlFor={labelId} aria-label={label}>{label}<span className={(mandatory) ? 'asterisk' : ''}>{(mandatory) ? '*' : ''}</span></InputLabel>
                    <Select
                        id={labelId}
                        name={labelId}
                        value={formikValue}
                        role="combobox"
                        tabIndex="0"
                        aria-expanded="false"
                        aria-haspopup="listbox"
                        inputProps={{
                            "aria-label": label || 'Select option',
                            "aria-describedby": title ? `${labelId}-desc` : undefined,
                            title 
                        }}
                        label={label}
                        displayEmpty
                        disabled={disabled ? disabled : false}
                        MenuProps={MenuProps}
                        onChange={formikChange}
                        renderValue={(selected) => { 
                            const opt = list.optionLists.find(o => String(o[list.value]) === String(selected));
                            const display = opt ? opt[list.key] : '';
                            return <span className={useEllipsis ? 'ellipsis' : undefined} title={title || display || label}>{display}</span>;
                        }}
                        onOpen={() => setTooltip(false)}
                        onClose={() => setTooltip(true)}
                        SelectDisplayProps={{
                            "aria-description": title
                        }}
                    >
                        {getOptions(list)}
                    </Select>
                </FormControl> :
                <>
                    <InputLabel htmlFor={labelId} aria-label={label}>{label}<span className={(mandatory) ? 'asterisk' : ''}>{(mandatory) ? '*' : ''}</span></InputLabel>
                    <FormControl variant={"outlined"} fullWidth>
                        <Tooltip title={onTooltip && isTooltip && !title ? onTooltip : ""} arrow>
                            <Select
                                error={(errors && touched) ? true : false}
                                name={labelId}
                                value={formikValue}
                                role="combobox"
                                tabIndex="0"
                                aria-expanded="false"
                                aria-haspopup="listbox"
                                aria-labelledby={`${labelId}-label`}
                                inputProps={{
                                    id: labelId,
                                    "aria-label": label,
                                    "aria-required": mandatory ? "true" : null,
                                    "aria-describedby": title ? `${labelId}-desc` : undefined,
                                    title
                                }}
                                SelectDisplayProps={{
                                    "aria-describedby": title ? `${labelId}-desc` : undefined
                                }}
                                displayEmpty
                                disabled={disabled ? disabled : false}
                                onChange={formikChange}
                                renderValue={(selected) => {
                                    const opt = list.optionLists.find(o => String(o[list.value]) === String(selected));
                                    const display = opt ? opt[list.key] : '';
                                    return <span className={useEllipsis ? 'ellipsis' : undefined} title={title || display || label}>{display}</span>;
                                }}
                                onOpen={() => setTooltip(false)}
                                onClose={() => setTooltip(true)}
                            >
                                {getOptions(list)}

                            </Select>
                        </Tooltip>
                        {errors && touched && <FormHelperText className="helperText">{errors}</FormHelperText>}
                    </FormControl>
                </>}
        </FormInputWrapper>
    )
}

/**
 * @param {{
 * label: string, 
 * labelId: string, 
 * formikValue: Object, 
 * formikChange: Function, 
 * isDoubled?: Boolean,
 * errors?: formik.errors.labelId,
 * touched?: formik.touched.labelId,
 * mandatory: Boolean,
 * dropdownData: Object
 * }} props 
 */
export const SelectGroupInput = (props) => {
    const { label, labelId, formikValue, formikChange, isDoubled, errors, touched, mandatory, dropdownData, disabled } = props;
    const { optionLists, key, value, groupLabel, groupOne, groupTwo } = dropdownData;
    return (
        <FormInputWrapper
            isDoubled={isDoubled ? isDoubled : null}
            className={isDoubled ? 'doubled' : null}
        >
            <InputLabel aria-label={label} htmlFor={labelId}>{label}<span className={(mandatory) ? 'asterisk' : ''}>{(mandatory) ? '*' : ''}</span></InputLabel>
            <FormControl variant="outlined" fullWidth>
                <Select
                    error={(errors && touched) ? true : false}
                    id={labelId}
                    name={labelId}
                    value={formikValue}
                    inputProps={{
                        "aria-required": mandatory ? "true" : null,
                        "aria-label": label
                    }}
                    displayEmpty
                    disabled={disabled}
                    onChange={formikChange}>
                    <ListSubheader style={{ pointerEvents: 'none' }}>{groupOne}</ListSubheader>
                    {getOptionsGroups(optionLists, key, value, true, groupLabel)}
                    {/* {groupTwo && <> */}
                    <ListSubheader style={{ pointerEvents: 'none' }}>{groupTwo}</ListSubheader>
                    {getOptionsGroups(optionLists, key, value, false, groupLabel)}
                    {/* </> } */}
                </Select>
                {errors && touched && <FormHelperText className="helperText">{errors}</FormHelperText>}
            </FormControl>
        </FormInputWrapper>
    )
}

export const PropertiesSelectInput = (props) => {
    const { SoValueZero,SoValueEmpty,SoValueNull, notification, customStyle, label, labelId, withoutLabel = false, formikValue, formikChange, isDoubled, errors, touched, mandatory, dropdownData, disabled, sortAsc = false, onTooltip, title } = props; 

    const [list, setList] = useState({ key: "", value: '', optionLists: [] })
    const [isTooltip, setTooltip] = useState(true);

    const [bindDropdownValue, setBindDropdownValue] = useState({})

    useEffect(()=>{
        if(SoValueZero){
            setBindDropdownValue({
                "uniqueId": 0,
                "displayText": '<Select one>',
                "isSelected": true
            })
        }
        if(SoValueEmpty){
            setBindDropdownValue({
                "uniqueId": '',
                "displayText": '<Select one>',
                "isSelected": true
            })
        }
        if(SoValueNull){
            setBindDropdownValue({
                "uniqueId": null,
                "displayText": '<Select one>',
                "isSelected": true
            })
        }
    },[SoValueZero,SoValueEmpty,SoValueNull])

    useEffect(() => {
        if (dropdownData?.optionLists?.length > 0) {
            const updatedList = dropdownData.optionLists.map((v, i) => {
                if (window.location.hash.indexOf('/system-manager/lookup-table-options/custom-grade-entry') > -1) {
                    if (v[dropdownData.key] === '' && Number(v[dropdownData.value]) === 0) {
                        v[dropdownData.key] = 'Default'
                    }
                } else {
                    if (v[dropdownData.key] === '' && Number(v[dropdownData.value]) === 0) {
                        v[dropdownData.key] = '<Select one>'
                    } else if (v[dropdownData.key] === '') {
                        v[dropdownData.key] = '<Select one>'
                    }
                }
                return v
            })
            setList({
                ...list,
                key: dropdownData.key,
                value: dropdownData.value,
                optionLists: ( Object.keys(bindDropdownValue).length > 0) ?
                    [bindDropdownValue,
                    ...updatedList
                    ]
                    :
                    updatedList
            })
        }
        else {
            setList({
                ...list,
                key: '',
                value: '',
                optionLists: []
            })
        }
    }, [dropdownData])


    if (sortAsc) {
        list.optionLists.sort((a, b) => {
            if (a.displayText != null) {
                // if((a.displayText).toUpperCase() === 'NONE') {
                //     return -1;
                // }
                if (a.displayText.startsWith("<") && a.displayText.endsWith(">")) {
                    return -1;
                }
                if (b.displayText.startsWith("<") && b.displayText.endsWith(">")) {
                    return 1;
                }
                if (a.displayText.toLowerCase() < b.displayText.toLowerCase()) {
                    return -1;
                }
                if (a.displayText.toLowerCase() > b.displayText.toLowerCase()) {
                    return 1;
                }
                return 0;
            }
        });
    }

    return (
        <FormInputWrapper style={customStyle}
            isDoubled={isDoubled ? isDoubled : null}
            className={isDoubled ? 'doubled' : null}
        >
            {withoutLabel ?
                <FormControl variant={"outlined"} fullWidth>
                    <InputLabel htmlFor={labelId} aria-label={label}>{label}<span className={(mandatory) ? 'asterisk' : ''}>{(mandatory) ? '*' : ''}</span></InputLabel>
                    <Select
                        id={labelId}
                        name={labelId}
                        value={formikValue}
                        inputProps={{
                            "aria-label": 'Without label',
                            title
                        }}
                        label={label}
                        displayEmpty
                        disabled={disabled ? disabled : false}
                        MenuProps={MenuProps}
                        onChange={formikChange}
                        renderValue={(selected) => { 
                            const opt = (list.optionLists || []).find(o => String(o[list.value]) === String(selected));
                            const display = opt ? opt[list.key] : '';
                            return <span title={title || display || label}>{display}</span>;
                        }}
                        onOpen={() => setTooltip(false)}
                        onClose={() => setTooltip(true)}
                        SelectDisplayProps={{
                            "aria-description": title
                        }}
                    >
                        {getOptionsInactive(list)}
                    </Select>
                </FormControl> :
                <>
                    <InputLabel htmlFor={labelId} aria-label={label}>{label}<span className={(mandatory) ? 'asterisk' : ''}>{(mandatory) ? '*' : ''}</span></InputLabel>
                    <FormControl variant={"outlined"} fullWidth>
                        <Tooltip title={onTooltip && isTooltip && !title ? onTooltip : ""} arrow>
                            <Select
                                error={(errors && touched) ? true : false}
                                id={labelId}
                                name={labelId}
                                value={formikValue}
                                inputProps={{
                                    "aria-label": label,
                                    "aria-required": mandatory ? "true" : null,
                                    title
                                }}
                                SelectDisplayProps={
                                    {
                                        "aria-description": title
                                    }
                                }
                                displayEmpty
                                disabled={disabled ? disabled : false}
                                onChange={formikChange}
                                renderValue={(selected) => {
                                    const opt = (list.optionLists || []).find(o => String(o[list.value]) === String(selected));
                                    const display = opt ? opt[list.key] : '';
                                    return <span title={title || display || label}>{display}</span>;
                                }}
                                onOpen={() => setTooltip(false)}
                                onClose={() => setTooltip(true)}
                            >
                                {getOptionsInactive(list)}

                            </Select>
                        </Tooltip>
                        {errors && touched && <FormHelperText className="helperText">{errors}</FormHelperText>}
                        {notification && <FormHelperText className="helperText">{notification}</FormHelperText>}
                    </FormControl>
                </>}
        </FormInputWrapper>
    )
}
